import React, { useEffect, useState } from "react";
import { Table, TableRow } from "../../../components/Table";
import StateBanks from "./StateBanks";

const MerchantStateView = ({ states, onGet }) => {
    const [filterColumns, setFilterColumns] = useState([]);
    const [tableData, setTableData] = useState([]);

    const columns = [
        {
            title: "State Name",
            name: "stateName",
        },
        {
            title: "Total Banks",
            name: "count",
            Cell: (row) => row?.banks?.length || 0
        }
    ];

    useEffect(() => {
        setFilterColumns(columns.map(c => c.name));
    }, []);

    useEffect(() => {
        if (states && typeof states === 'object') {
            const formatted = Object.entries(states).map(([key, val]) => ({
                stateName: key,
                banks: val
            }));
            setTableData(formatted);
        }
    }, [states]);

    return (
        <div>
            <Table
                columns={columns}
                filterColumns={filterColumns}
                data={tableData}
                isData={!!tableData.length}
                count={tableData.length}
                isExpandable={true}
                minHeight={100}
            >
                {tableData.map((val, i) => (
                    <TableRow
                        key={i}
                        columns={columns}
                        filterColumns={filterColumns}
                        item={val}
                        isExpandable={true}
                    >
                        <StateBanks banks={val.banks} onGet={onGet} />
                    </TableRow>
                ))}
            </Table>
        </div>
    );
};

export default MerchantStateView;
